import React, { FC, useEffect } from "react";
import { observer } from "mobx-react";
import { Alert, List, Pagination, Row } from "antd";
import { useStores } from "../store";
import DOMPurify from "dompurify";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
const DashboardComponent: FC<{}> = observer(() => {
    const { todoStore } = useStores();
    const defaultPageSize = 5;
    useEffect(() => {
        todoStore.getTodos({
            is_done: 0,
            is_mine_only: 1,
            with: "post",
            limit: defaultPageSize
        });
    }, []);

    const handlePagination = (page: number, pageSize: number) => {
        todoStore.getTodos({
            is_done: 0,
            is_mine_only: 1,
            with: "post",
            limit: defaultPageSize,
            page
        });
    };

    return (
        <div className="wp-styleguide">
            <List
                itemLayout="horizontal"
                size="small"
                dataSource={todoStore.todos}
                renderItem={(t) => (
                    <List.Item key={t.id}>
                        <a href={t.post.link}>
                            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t.description) }}></span>
                        </a>
                    </List.Item>
                )}
            />
            {todoStore.todos.length > 0 && (
                <Row justify="end" wrap={false}>
                    <Pagination
                        simple
                        defaultCurrent={1}
                        current={todoStore.currentPage}
                        onChange={handlePagination}
                        pageSize={defaultPageSize}
                        total={todoStore.total}
                    />
                </Row>
            )}
            {todoStore.errors.length > 0 &&
                todoStore.errors.map((m, index) => <Alert key={index} message={m} type={todoStore.errorType} />)}
        </div>
    );
});

export { DashboardComponent };
